
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collection/[userId]",
      function () {
        return require("private-next-pages/collection/[userId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collection/[userId]"])
      });
    }
  